export const USER = "user";
export const AUTH_TOKEN = "authToken";
